module.exports = __webpack_public_path__ + "img/btc.7502eb49.png";